export const MailingStateText = Object.freeze({
	DRAFT: 'Concept',
	FINAL: 'Definitief',
	OFFERED: 'Aangeboden',
	CANCELLED: 'Geannuleerd',
});
